import { createStore } from 'vuex';

import advert from './modules/advert.js';
import app from './modules/app.js';

const store = createStore({
  strict: true,
  modules: {
    advert,
    app,
  },
});

// Note: store.$api is injected in main.ts to enable `this.$api` access in Vuex actions

export default store;
